import React, { useCallback, useEffect, useMemo } from 'react';
import styles from './SavedFiltersList.module.scss';
import { Alert, Spin, Tag, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  chooseDocumentFilter,
  deleteDocumentFilter,
  fetchDocumentFilters,
} from '../../store/actions/documentFilter/documentFilterActions';
import setDocumentDefaultFilter from '../../requests/setDocumentDefaultFilter';
import { shortFilterName } from '../../../../helpers/filterName';

const { confirm } = Modal;

const SavedFiltersList = () => {
  const dispatch = useDispatch();
  const filters = useSelector(
    (store) => store.documentFilterStore.filters.data
  );
  const chosenFilterId = useSelector(
    (store) => store.documentFilterStore.chosenFilterId
  );
  const isLoading = useSelector(
    (store) => store.documentFilterStore.filters.isLoading
  );

  useEffect(() => {
    dispatch(fetchDocumentFilters());
  }, []);

  const clickChooseFilter = useCallback((id) => {
    setDocumentDefaultFilter(id);
    dispatch(chooseDocumentFilter(id));
  }, []);

  const savedFiltersList = useMemo(() => {
    return filters.map((filter) => (
      <Tag
        color={chosenFilterId === filter.id ? '#034cd7' : null}
        className={styles.tag}
        onClick={() => clickChooseFilter(filter.id)}
        key={filter.id}
        closable
        onClose={(e) => confirmDeleteFilter(e, filter.id)}
      >
        <span style={{ color: chosenFilterId === filter.id ? '#fff' : null }}>
          {shortFilterName(filter.name)}
        </span>
      </Tag>
    ));
  }, [filters, chosenFilterId]);

  const confirmDeleteFilter = useCallback((e, id) => {
    e.preventDefault();
    confirm({
      title: 'Вы действительно хотите удалить этот фильтр?',
      onOk() {
        dispatch(deleteDocumentFilter(id));
      },
      onCancel() {},
    });
  }, []);

  return (
    <>
      <h3>Мои фильтры</h3>
      <Spin size="small" spinning={isLoading}>
        <div className={styles.savedFiltersTags}>
          {savedFiltersList.length ? (
            savedFiltersList
          ) : (
            <div>Нет сохраненных фильтров</div>
          )}
        </div>
      </Spin>
    </>
  );
};

export default SavedFiltersList;
